import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../utils/api';
import '../StylesComponents/signin-page.css';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('VALIDATION_ERROR: Passwords do not match.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await api.post('/api/auth/reset-password', { resetToken: token, newPassword: password });
      setIsSuccess(true);
      setTimeout(() => navigate('/signin'), 3000);
    } catch (err) {
      console.error('RESET_ERROR:', err);
      setError(err.response?.data?.error || 'Failed to update access key.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="signin-page-wrapper">
        <div className="signin-container glass-card animate-slide-up">
          <h1 className="signin-heading">INVALID_LINK</h1>
          <p style={{ color: '#ff4444', fontSize: '11px' }}>RECOVERY_TOKEN_MISSING_OR_CORRUPT</p>
          <div className="auth-links">
            <a href="/forgot-password">REQUEST_NEW_LINK</a>
          </div>
        </div>
      </div>
    );
  }

  if (isSuccess) {
    return (
      <div className="signin-page-wrapper">
        <div className="signin-container glass-card animate-slide-up">
          <div className="signin-status-tag">
            <span className="pulse-dot"></span>
            PROTOCOL_RESTORED
          </div>
          <h1 className="signin-heading">SUCCESS</h1>
          <p style={{ color: '#888', fontSize: '12px' }}>Access key updated successfully. Redirecting to terminal...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="signin-page-wrapper">
      <div className="signin-container glass-card animate-slide-up">
        <div className="signin-status-tag">
          <span className="pulse-dot"></span>
          ACCESS_KEY_RESET
        </div>
        <h1 className="signin-heading">RESET</h1>
        <form className="signin-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label>NEW PASSWORD</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="technical-input"
              placeholder="••••••••"
            />
          </div>
          <div className="input-group">
            <label>CONFIRM NEW PASSWORD</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="technical-input"
              placeholder="••••••••"
            />
          </div>

          {error && <p style={{ color: '#ff4444', fontSize: '10px', marginTop: '10px' }}>{error}</p>}

          <button type="submit" className="brutalist-btn brutalist-btn-primary signin-button" disabled={isLoading}>
            {isLoading ? 'UPDATING...' : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
